import { constants } from '@/utils/constants';

// Media cache shared with the service worker (public/sw.js serves it cache-first, so playback
// keeps working offline). Keep the name in sync with CONTENT_CACHE there.
export const CONTENT_CACHE = constants.PREFIX + 'contents';

const supported = () => typeof window !== 'undefined' && 'caches' in window;

/**
 * Downloads every url that is not cached yet. Only successful responses are stored.
 * Resolves to the urls that could not be fetched (e.g. offline).
 */
export const cacheContents = async (urls) => {
  if (!supported() || !urls?.length) return [];

  const cache = await caches.open(CONTENT_CACHE);
  const results = await Promise.allSettled(
    urls.map(async (url) => {
      if (await cache.match(url, { ignoreVary: true })) return;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      await cache.put(url, response);
    }),
  );

  return urls.filter((_, i) => results[i].status === 'rejected');
};

/** Removes cached media no longer referenced, so TV storage does not fill up over time. */
export const pruneContents = async (keepUrls) => {
  if (!supported()) return;

  const keep = new Set(keepUrls);
  const cache = await caches.open(CONTENT_CACHE);
  const requests = await cache.keys();
  await Promise.all(
    requests.filter((r) => !keep.has(r.url)).map((r) => cache.delete(r)),
  );
};
